import { createStore, applyMiddleware } from "redux";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import createRootReducer from "../reducers/index.js";
import { composeWithDevTools } from "redux-devtools-extension";
import createSagaMiddleware from "redux-saga";
import rootSaga from "../sagas/index";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { createBlacklistFilter } from "redux-persist-transform-filter";
import thunk from "redux-thunk";
import { errorCatcherMiddleware } from "./errorCatcherMiddleware.js";

const history = createBrowserHistory();

const sagaMiddleware = createSagaMiddleware();

const saveSubsetBlacklistFilter = createBlacklistFilter("login", [
  "isLoading",
  "password",
  "inactive"
]);
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["login", "config", "id"],
  transforms: [saveSubsetBlacklistFilter],
};

const persistedReducer = persistReducer(
  persistConfig,
  createRootReducer(history)
);

const store = createStore(
  persistedReducer,
  {},
  composeWithDevTools(
    applyMiddleware(
      errorCatcherMiddleware,
      sagaMiddleware,
      thunk,
      routerMiddleware(history)
    )
  ),
);

let persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export { store, history, persistor };
